import { Component, EventEmitter, Inject, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { DataStateChangeEvent, GridComponent, GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, FilterDescriptor, process, State } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { CSEService } from '../../services/cse.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import { SearchCarrierSalesAvailableLoads } from '../../models/models';

@Component({
    selector: 'carrier-rfq-grid',
    templateUrl: './carrier-rfq-grid.component.html',
    standalone: false
})
export class CarrierRFQGrid implements OnInit, OnChanges {
    @Input() opportunityID: number = 0;
    @Input() viewType: string = "";

    @ViewChild(GridComponent, { static: false }) public rfqLoadsGrid!: GridComponent;

    private rfqLoadList: SearchCarrierSalesAvailableLoads[] = [];

    public gridState: State = { skip: 0, take: 40, sort: [{ dir: 'asc', field: 'arrivalStartDate' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(public dialog: MatDialog, private ngZone: NgZone, private cseService: CSEService,
        private notificationService: NotificationService, private orderService: OrderService, private utilService: UtilService,
        @Inject('BASE_URL') private baseUrl: string) {
    }

    ngOnInit() {
        if (this.opportunityID > 0) {
            this.getRFQLoads();
        }
    }

    ngOnChanges() {
        //this.updateLoads();
        //console.log("ngOnChanges", this.isShowBulkTender);
    }

    private getRFQLoads() {
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierSalesAvailableLoadsByOpportunityID(this.opportunityID).subscribe(result => {
            this.utilService.isLoading = false;
            this.rfqLoadList = result.resultCollection;
            this.rfqLoadList = this.rfqLoadList.filter(f =>
                f.quoteOrderLineType == "RFQ" && f.finalCost == 0
                || f.quoteOrderLineType == "RFQP"
            );
            this.rfqLoadList.forEach(load => {
                if (load.arrivalStartDate != null) {
                    load.arrivalStartDate = new Date(load.arrivalStartDate!);
                }
            });

            this.gridData = process(this.rfqLoadList, this.gridState);
            this.fitColumns();
        });
        //console.log("updateLoads", this.viewType, this.filteredLoads);
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.rfqLoadsGrid == null) return;
            this.rfqLoadsGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridData = process(this.rfqLoadList, this.gridState);
        this.fitColumns();
    }
}
